module.exports = __webpack_public_path__ + "img/ddc1a032-1832-4334-b8dd-be8068da45df.ca07d6e6.webp";